import { Box } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { PAYMENT_SEARCH } from "Application/RequestTypes";
import { PAYMENT_DETAIL, getUrl } from "Infrastructure/config/routesConfig";
import SearchTable from "pages/components/Molecules/SearchTable";
import { Link } from "react-router-dom";
import { formatDateTime, formatPrice } from "pages/Utils/Formats";
import { Payment } from "Domain/Payment/Entity/Payment";
import PaymentStatusChip from "pages/components/Status/PaymentStatusChip";
import { FilterConfig } from "pages/components/Molecules/SearchFilter";
import { useTranslation } from "react-i18next";

export default function PaymentList() {
  const { t } = useTranslation();
  const columns: GridColDef<Payment>[] = [
    {
      field: "publicId",
      flex: 1,
      renderCell: (params) => (
        <Link to={getUrl(PAYMENT_DETAIL, { id: params.row.publicId })}>
          {params.row.publicId}
        </Link>
      ),
    },
    {
      field: "paymentAmount",
      flex: 1,
      valueGetter: (value, row) => formatPrice(value),
    },
    {
      field: "date",
      flex: 1,
      type: "string",
      valueGetter: (value, row) => formatDateTime(row.date),
    },
    {
      field: "status",
      flex: 1,
      renderCell: (params) => <PaymentStatusChip status={params.row.status} />,
    },
  ];
  return (
    <>
      <SearchTable<Payment>
        columns={columns}
        additionalFilters={{}}
        endpoint={PAYMENT_SEARCH}
        filterConfig={getSearchFilters(t)}
      />
    </>
  );
}

function getSearchFilters(t: Function) {
  const paymentStatuses = ["TO_PAY", "PAYED"];
  return {
    status: paymentStatuses.map((status: string) => ({
      label: t(`STATUS.LABEL.payment.${status}`),
      value: status,
    })),
  } as FilterConfig;
}
